import React, { useState, useEffect, useContext } from "react";
import classes from "./VerifyotpPage.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LanguageContext } from "./LanguageContext";
import axios from "axios";
import LanguageSelector from "./LanguageSelector";

const content = {
  "3": {
    title: "Confirm Subscription",
    desc: "Please enter the OTP sent to your phone",
    button: "Confirm",
  },
  "2": {
    title: "تأكيد الاشتراك",
    desc: "يرجى إدخال رمز التحقق المرسل إلى هاتفك",
    button: "تأكيد",
  },
};

const VerifyotpPage = ({ onVerify }) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const navigate = useNavigate();

  const [msisdn, setMsisdn] = useState(null);
  const [uniqid, setUniqid] = useState(null);
  const [clickidv1, setClickIDv1] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();

  const [mcpuniqid, setMcpuniqid] = useState("");
  const [antifraudId, setAntifraudId] = useState("")
  const [clickID, setClickID] = useState("");

  const { lang } = useContext(LanguageContext);
  const t = content[lang] || content["3"];

  useEffect(() => {
    document.body.dir = lang === "2" ? "rtl" : "ltr";

    const loadAntiFraud = async () => {
      try {
        const userIp = await getUserIP();

        const generateClickId = () => {
          return (
            "CLK" +
            Date.now() +
            Math.random().toString(36).replace(/[^a-z0-9]/gi, "").substring(0, 10)
          ).substring(0, 50);
        };

        const response = await axios.get("/antifraud/v2", {
          params: {
            userIp,
            msisdn,
            clickId: generateClickId()
          },
        });
        console.log(response?.data?.data, "response----------")

        if (response.data.success) {
          const click = response.data.clickId;
          const mcp = response.data.mcpuniqid || "";
          const antifraud = response.data.antifrauduniqid

          setClickID(click);
          setMcpuniqid(mcp);
          setAntifraudId(antifraud)

          localStorage.setItem("clickID", click);
          localStorage.setItem("mcp", mcp);

          const scriptFromAPI = response?.data?.data;

          if (scriptFromAPI) {
            const oldScript = document.getElementById("anti-fraud-script");
            if (oldScript) {
              oldScript.remove();
            }

            const scriptTag = document.createElement("script");
            scriptTag.id = "anti-fraud-script";
            scriptTag.type = "text/javascript";

            scriptTag.textContent = scriptFromAPI;

            document.head.appendChild(scriptTag);
          }

          console.log("AntiFraud success:", response.data);
        } else {
          console.error("AntiFraud failed:", response.data);
        }
      } catch (err) {
        console.error(" AntiFraud error:", err);
      }
    };

    if (msisdn) {
      loadAntiFraud();
    }
  }, [lang, msisdn]);

  const getUserIP = async () => {
    try {
      const res = await axios.get("https://api.ipify.org?format=json");
      return res.data.ip;
    } catch (err) {
      console.error("IP fetch failed:", err);
      return "0.0.0.0";
    }
  };

  useEffect(() => {
    setMsisdn(searchParams.get("msisdn"));
    setUniqid(searchParams.get("uniqid"));
    setClickIDv1(searchParams.get("ClickID"));
  }, [searchParams]);


  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").slice(0, 6);
    if (!/^\d+$/.test(pasteData)) return;

    const newOtp = pasteData.split("");
    setOtp(newOtp);

    newOtp.forEach((digit, i) => {
      const input = document.getElementById(`otp-${i}`);
      if (input) input.value = digit;
    });
  };



  const handleVerify = async () => {

    const finalOtp = otp.join("");

    if (!antifraudId) {
      alert("AntiFraud not ready yet");
      return;
    }

    console.log(finalOtp.length)

    if (finalOtp.length != 4) {
      alert(lang === "ar" ? "ادخل رمز صحيح" : "Enter valid OTP");
      return;
    }

    try {
      const res = await axios.get("/otp/verifyPin",
        {
          params: {
            user: "Digitalabs",
            password: "DiGit0L02022",
            msisdn: msisdn,
            shortcode: "2055",
            serviceId: "22",
            spId: "3021",
            LanguageID: lang === "ar" ? 2 : 3,
            ChannelID: "22800",
            // ClickID:clickID,
            ClickID: antifraudId,
            // ClickID:generateClickId(),
            pincode: finalOtp
          }
        });

      if (res?.data?.status == "Success" || res?.data?.data?.status == "Success") {
        window.location.href = 'https://asiacell.door2game.com/'
      }

      else {
        alert(res.data.msg || "Failed");
      }
    } catch (err) {
      console.error("OTP Error:", err);
      alert("Error verifying OTP");
    }
  };

  return (
    <div className={classes.container}>
      <LanguageSelector />
      <div className={classes.card}>
        <h2>{t.title}</h2>
        <p>{t.desc}</p>


        <div className={classes.otpWrapper} onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className={classes.otpInput}
            />
          ))}
        </div>

        <button
          className={`AFsubmitbtn`}
          id="AFsubmitbtn"
          onClick={handleVerify}
        >
          {t.button}
        </button>
      </div>
    </div>
  );
};

export default VerifyotpPage;